// extracted by mini-css-extract-plugin
var _1 = "ComparePostsView-module__animateUploadProgressBarWidth--qvyct";
var _2 = "ComparePostsView-module__animatedBackground--Ewb5B";
var _3 = "ComparePostsView-module__container--Js2KX";
var _4 = "ComparePostsView-module__editorContainer--wYmgN";
var _5 = "ComparePostsView-module__editorRoot--ZtnbX";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "editorContainer", _5 as "editorRoot" }
